module.exports = __webpack_public_path__ + "media/AUDIO 10.792451cd.mp3";